import Metrics from '../Metrics'
import { BoxSizes, Chart, Dashboard } from './types'

const EventSpace: Dashboard = {
    id: 'ES',
    name: 'Event Space',
    daterange: true,
    metrics: [
        {
            type: Metrics.EVENTSPACE_DWELLTIMELINE,
            'box-size': BoxSizes.BIG,
            chart: Chart.Timeline,
            color: '#2f9b8f',
            title: 'dashboard-eventspace-dwelltimeline',
            count: 'dashboard-count-seconds-average',
        },
        {
            type: Metrics.EVENTSPACE_STORES_TOP,
            'box-size': BoxSizes.MID,
            chart: Chart.List,
            title: 'dashboard-stores-top',
            count: 'dashboard-count-stores',
            'count-data': 'dashboard-count-interactions',
        },
        {
            type: Metrics.EVENTSPACE_INTERACTIONS_GROUPED,
            'box-size': BoxSizes.MID,
            chart: Chart.Bars,
            title: 'dashboard-interactions-grouped',
            count: 'dashboard-count-interactions',
            'count-data': 'dashboard-count-interactions',
        },
        {
            type: Metrics.GROUP,
            'box-size': BoxSizes.THIRD,
            metrics: [
                {
                    type: Metrics.EVENTSPACE_INTERACTIONS,
                    'box-size': BoxSizes.BIG,
                    title: 'dashboard-interactions',
                },
                {
                    type: Metrics.EVENTSPACE_PRODUCTS_TOP,
                    'box-size': BoxSizes.BIG,
                    title: 'dashboard-eventspace-products-top',
                },
                {
                    type: Metrics.EVENTSPACE_CONTENT_TOP,
                    'box-size': BoxSizes.FULLWIDTH,
                    title: 'dashboard-content-top',
                },
            ],
        },
    ],
}

export default EventSpace
